/* eslint-disable import/prefer-default-export */

export const sortedByTimestamp = [
  {
    id: 'timestamp',
    desc: false
  }
]
